import { observable, makeObservable } from 'mobx'
import moment from 'moment'
import * as R from 'ramda'
import i18n from 'i18next'
import { validator } from '../../utils/Validator'
import surveyApi from '../../API/Survey'

class SettingStore {
    constructor(props) {
        makeObservable(this)
        this.props = props
        this.store = this.props.store
        this.survey = this.store.survey
        this.surveyId = this.props.surveyId
        this.isTemplate = this.props.isTemplate
    }

    componentObject = {}

    @observable primaryLanguageOptions = []

    @observable selectedLanguages = []

    @observable surveyStatus = {
        style: '',
        label: '',
        icon: null,
    }

    @observable dataLoading = true

    @observable noOfResponses = 0

    @observable surveyName = ''

    @observable allowEditSurveyName = false

    @observable isTest = false

    @observable eventName = ''

    @observable topic = ''

    @observable audience= ''

    @observable isPrimary = undefined

    @observable eventOpenDate = ''

    @observable eventCloseDate = ''

    @observable surveycloseDate = ''

    @observable numVisitorsOrExhibitors = ''

    @observable primaryLanguageOption = ''

    @observable selectedCountry = ''

    @observable selectedCity = ''

    @observable cityother = ''

    @observable allowEditCityotherEV = false

    @observable venueEV = []

    @observable selectedVenue = ''

    @observable venueOther = ''

    @observable allowEditVenueotherEV = false

    @observable eventformat = []

    @observable selectedEventFormat = ''

    @observable countryCE = []

    @observable selectedCountryCE =''

    @observable stateCE = []

    @observable selectedStateCE = {
        value: -1,
        label: i18n.t('form.general.select_an_item'),
    }

    @observable cityCE = []

    @observable selectedCityCE = ''

    @observable defaultcomparison = []

    @observable selectedDefaultcomparison = ''

    @observable surveyClosed = false

    @observable cities = []

    @observable venues = []

    @observable venuesEditable = false

    allowUpdate = false

    @observable mergeFieldOptions = []

    @observable deleteModalOpen = false

    @observable isOpenSurveyModalOpen = false

    @observable isConfirmSurveyCloseOpen = false

    @observable showLocaleWarning = false

    @observable availableTags = []

    @observable recordTags = {}

    @observable settingStoreReady = false

    @observable showPublishConfirmationModal = false

    numVisitors = [
        { value: 250, label: 'Less than 500' },
        { value: 500, label: '500 - 1,000' },
        { value: 1500, label: '1,000 - 2,000' },
        { value: 2500, label: '2,000 - 3,000' },
        { value: 4000, label: '3,000 - 5,000' },
        { value: 6250, label: '5,000 - 7,500' },
        { value: 8750, label: '7,500 - 10,000' },
        { value: 12500, label: '10,000 - 15,000' },
        { value: 20000, label: '15,000 - 25,000' },
        { value: 37500, label: '25,000 - 50,000' },
        { value: 75000, label: '50,000 - 100,000' },
        { value: 100000, label: 'More than 100,000' },
    ]

    numExhibitors = [
        { value: 5, label: 'Less than 10' },
        { value: 18, label: '10 - 25' },
        { value: 38, label: '26 - 50' },
        { value: 75, label: '51 - 100' },
        { value: 150, label: '101 - 200' },
        { value: 250, label: '201 - 300' },
        { value: 350, label: '301 - 400' },
        { value: 450, label: '401 - 500' },
        { value: 750, label: '501 - 1000' },
        { value: 1000, label: 'More than 1000' },
    ]

    numDelegates = [
        { value: 12, label: 'Less than 25' },
        { value: 25, label: '25 - 49' },
        { value: 50, label: '50 - 100' },
        { value: 100, label: '100 - 249' },
        { value: 250, label: '250 - 499' },
        { value: 500, label: '500 - 999' },
        { value: 1000, label: '1000 - 4999' },
        { value: 5000, label: '5000 - 9999' },
        { value: 10000, label: '10000 or more' },
    ]

    eventTypes = [
        {
            value: 'L',
            label: 'A live / in-person event',
        },
        {
            value: 'V',
            label: 'A virtual / online event',
        },
        {
            value: 'H',
            label: 'A hybrid event (both live and virtual)',
        },
    ]

    initStore = async () => {
        await this.setInitialVariables()
        this.changeCountry(this.store.selectedCountry, false)
        this.changeCity(this.store.selectedCity, false)
        this.changeVenue(this.store.selectedVenue, false)
        this.allowUpdate = true
        this.isTest = this.survey.metadata.isTest
        this.dataLoading = false
    }

    addValidators = () => {
        validator.addValidator('numberOf', this.validateNumVisitors)
        validator.addValidator('venue', this.validate)
        validator.addValidator('endDate', this.validateClosingDate)
        validator.addValidator('startDate', this.validateOpenDate)
        validator.addValidator('defaultLocale', this.validatePrimaryLanguage)
        validator.addValidator('locales', this.validateLanguages)
        validator.addValidator('name', this.validateName)
    }

    removeValidators = () => {
        validator.removeValidator('numberOf')
        validator.removeValidator('venue')
        validator.removeValidator('endDate')
        validator.removeValidator('startDate')
        validator.removeValidator('defaultLocale')
        validator.removeValidator('locales')
        validator.removeValidator('name')
    }

    setInitialVariables = async () => {
        const { store } = this.props
        const { survey } = store
        const { metadata } = survey
        const { industrySpecificInfo } = metadata.productInfo
        const {
            startDate, endDate, industry, numVisitors, numExhibitors,
        } = industrySpecificInfo
        const { closeDate, taxonomy } = metadata
        const { surveyType, respondentType } = taxonomy
        await this.checkPrimary()
        survey.saveOnChange = true
        survey.includeQuestions = false
        store.surveyLanguages = store.localeOptions
            .filter((lang) => (survey.metadata.locales.indexOf(lang.value) > -1))
        this.getPrimaryLanguages()
        this.getSelectedLanguages()
        const data = await store.http.get('/refcode/country')
        this.getStatus()
        this.noOfResponses = store.noOfResponses
        this.surveyName = store.survey.title
        this.getSurveyEmbedding()
        store.countries = data.response.reduce((arr, { description, name }) => {
            arr.push({
                value: name,
                label: description,
            })
            return arr
        }, [])
        this.respondentEditable = survey.pages.reduce((editable, page) => {
            if (page.pageType === 'ST') {
                editable = editable && page.questions.length === 0
            }
            return editable
        }, true)
        this.respType = survey.metadata.taxonomy.respondentType
        store.defaultYrOnYrSurveyId = survey.metadata.defaultYrOnYrSurveyId
            ? store.lastYearSurveys
                .find(((yrOnYr) => yrOnYr.value === survey.metadata.defaultYrOnYrSurveyId)) : {
                label: i18n.t('form.general.please_select_ellipsis'),
                value: '00000000-0000-0000-0000-000000000000',
            }
        this.defaultcomparison = store.lastYearSurveys
        this.selectedDefaultcomparison = store.defaultYrOnYrSurveyId
        if (survey.metadata.productInfo.industrySpecificInfo.venueId) {
            const venue = await this.getVenue()
            store.selectedVenue = {
                label: venue.name,
                value: venue.venueId,
            }
            store.selectedCountry = store.countries.find((country) => country.value === venue.code)
            if (store.selectedCountry) {
                const cities = await this.getCities(store.selectedCountry.value)
                store.selectedCity = cities
                    .find((city) => city.label.toLowerCase() === venue.city.toLowerCase())
            }
        } else if (survey.metadata.productInfo.industrySpecificInfo.industry === 'CE' && survey.metadata.productInfo.industrySpecificInfo.venue) {
            const { venue } = survey.metadata.productInfo.industrySpecificInfo
            const venueDetails = venue.split('|')
            store.selectedVenue = {
                label: venue,
                value: venue,
            }
            store.selectedCountry = store.countries
                .find((country) => country.label === venueDetails[2])
            if (store.selectedCountry) {
                const cities = await this.getCities(store.selectedCountry.value)
                store.selectedCity = cities
                    .find((city) => city.label.toLowerCase() === venueDetails[1].toLowerCase())
                    || { label: venueDetails[1], value: venueDetails[1] }
                // eslint-disable-next-line prefer-destructuring
                store.selectedState = venueDetails[3]
                // eslint-disable-next-line prefer-destructuring
                this.venueOther = venueDetails[0]
            }
        }
        // await this.getMergeFields()
        this.availableTags = this.isTemplate
            ? [] // use instead <TemplateCustomTags />
            : await store.getAvailableTags({
                oid: 7,
                industry,
                productType: survey.metadata.productInfo.industrySpecificInfo.productType,
                respondentType,
                surveyType,
                portfolioId: survey.portfolioId,
            })

        this.recordTags = this.isTemplate
            ? [] // use instead <TemplateCustomTags />
            : await store.getRecordTags(7, survey.id)

        this.selectedEventFormat = this.eventTypes
            .find((item) => item.value === survey.metadata.productInfo
                .industrySpecificInfo.eventType)

        this.surveycloseDate = moment(closeDate).tz(this.store.timeZone)
        this.eventOpenDate = moment(startDate)
        this.eventCloseDate = moment(endDate)

        this.eventName = survey.getProductName(this.store.productLocales)
        this.audience = i18n.t(`respondentType.${industry}.${respondentType}`)
        this.topic = i18n.t(`surveyType.${industry}.${surveyType}`)

        if (industry === 'CE') {
            this.numVisitorsOrExhibitors = this.numDelegates.find(
                ({ value }) => value === numVisitors,
            )
        } else if (respondentType === 'VI') {
            this.numVisitorsOrExhibitors = this.numVisitors.find(
                ({ value }) => value === numVisitors,
            )
        } else {
            this.numVisitorsOrExhibitors = this.numExhibitors.find(
                ({ value }) => value === numExhibitors,
            )
        }

        this.primaryLanguageOption = this.store.localeOptions
            .find(({ value }) => value === survey.metadata.defaultLocale)

        this.settingStoreReady = true
    }

    getPrimaryLanguages = () => {
        const url = process.env.ENVIRONMENT === 'production' ? 'explori' : 'staging.explori'
        this.primaryLanguageOptions = this.store.surveyLanguages.map((lang) => ({
            ...lang,
            src: `https://surveys.${url}.com/assets/images/flags/${lang.value}.png`,
        }))
    }

    getSelectedLanguages = () => {
        const { store } = this.props
        const { survey } = store
        this.selectedLanguages = store.localeOptions.map((option) => ({
            label: option.label,
            value: option.value,
            checked: survey.metadata.locales.indexOf(option.value) > -1,
        }))
    }

    hanldeAllowEdit = (parameter) => {
        switch (parameter) {
            case 'surveyName':
                this.onBlurSurveyName(this.surveyName)
                break
            case 'cityOther':
                this.allowEditCityotherEV = !this.allowEditCityotherEV
                break
            case 'venueOther':
                this.allowEditVenueotherEV = !this.allowEditVenueotherEV
                this.validateVenueOther()
                break
            default:
                break
        }
    }

    setTag = ({ name, value }) => {
        console.log('setTag', name, value)
        this.recordTags[name] = value

        this.saveTags(this.surveyId)
    }

    saveTags = async (recordId) => {
        const { store } = this
        try {
            store.saveTags(recordId, 7, this.availableTags, this.recordTags)
            store.addNotification(null, i18n.t('settings.notification.success'), 'success')
        } catch (e) {
            console.error(e)
            store.addNotification(null, i18n.t('settings.notification.error'), 'error')
        }
    }

    setSurveyName = ({ value }) => {
        this.surveyName = value
    }

    onBlurSurveyName = (value) => {
        const { store } = this.props
        const { survey } = store
        survey.title = value
        this.validateName()
        if (survey.saveOnChange) {
            store.updateBreadcrump('surveyTitle', survey.title)
            surveyApi.updateSettings({
                title: survey.title,
                allowQuotas: survey.metadata.allowQuotas,
            }, store)
        }
    }

    validateName = () => {
        const { store } = this.props
        const { survey } = store
        validator.errors.set('name', !survey.title)
    }

    togglePrimarySwitch = () => {
        this.isPrimary = !this.isPrimary
        this.setIsPrimary()
    }

    changePrimaryLanguage = (obj) => {
        this.primaryLanguageOption = obj
        const { store } = this.props
        const { survey } = store
        survey.metadata.defaultLocale = obj.value
        this.validatePrimaryLanguage()
        if (survey.saveOnChange) {
            surveyApi.updateSettings({
                defaultLocale: obj.value,
                allowQuotas: survey.metadata.allowQuotas,
            }, store)
        }
        this.selectedLanguages = []
        this.getSelectedLanguages()
    }

    validatePrimaryLanguage = () => {
        const { store } = this.props
        const { survey } = store
        const isValid = store.surveyLanguages.length <= 1 || survey.metadata.defaultLocale
        validator.errors.set('defaultLocale', !isValid)
    }

    changeNumVisitors = (obj) => {
        const { store } = this.props
        const { survey } = store
        const { respondentType } = survey.metadata.taxonomy
        this.numVisitorsOrExhibitors = obj
        if (respondentType === 'VI') {
            survey.metadata.productInfo.industrySpecificInfo.numVisitors = obj.value
        } else {
            survey.metadata.productInfo.industrySpecificInfo.numExhibitors = obj.value
        }
        this.validateNumVisitors()
        if (survey.saveOnChange) {
            surveyApi.updateSettings({
                productInfo: survey.metadata.productInfo.toJSON(),
                allowQuotas: survey.metadata.allowQuotas,
            }, store)
        }
    }

    validateNumVisitors = () => {
        validator.errors.set('numberOf', !this.numberOf || !this.numberOf.value)
    }

    changeEventOpenDate = (obj) => {
        const { store } = this.props
        const { survey } = store
        this.openDate = obj
        this.validateOpenDate()
        if (!validator.errors.get('startDate')) {
            survey.metadata.productInfo.industrySpecificInfo.startDate = obj
            if (survey.saveOnChange) {
                surveyApi.updateSettings({
                    productInfo: survey.metadata.productInfo.toJSON(),
                    allowQuotas: survey.metadata.allowQuotas,
                }, store)
            }
        }
    }

    validateOpenDate = () => {
        const { store } = this.props
        const { survey } = store
        validator.errors.set('startDate', !survey.validateDate(this.openDate))
    }

    changeEventCloseDate = (obj) => {
        const { store } = this.props
        const { survey } = store
        this.endDate = obj
        this.validateClosingDate()
        if (!validator.errors.get('endDate')) {
            survey.metadata.productInfo.industrySpecificInfo.endDate = obj
            if (survey.saveOnChange) {
                surveyApi.updateSettings({
                    productInfo: survey.metadata.productInfo.toJSON(),
                    allowQuotas: survey.metadata.allowQuotas,
                }, store)
            }
        }
    }

    validateClosingDate = () => {
        const { store } = this.props
        const { survey } = store
        validator.errors.set('endDate', !survey.validateDate(this.endDate))
    }

    changeEventFormat = (obj) => {
        const { store } = this.props
        const { survey } = store
        this.selectedEventFormat = obj
        if (survey.saveOnChange) {
            survey.metadata.productInfo.industrySpecificInfo.eventType = obj.value
            surveyApi.updateSettings({
                productInfo: survey.metadata.productInfo.toJSON(),
                allowQuotas: survey.metadata.allowQuotas,
            }, store)
        }
    }

    changeDefaultcomparison = (value) => {
        this.selectedDefaultcomparison = value
        this.updateYrOnYr(value)
    }

    updateYrOnYr = (obj) => {
        const { store } = this.props
        const { survey } = store
        store.defaultYrOnYrSurveyId = obj
        survey.metadata.defaultYrOnYrSurveyId = store.defaultYrOnYrSurveyId.value
        surveyApi.updateSettings({
            defaultYrOnYrSurveyId: survey.metadata.defaultYrOnYrSurveyId,
            allowQuotas: survey.metadata.allowQuotas,
        }, store)
    }

    onLicenceTypeChange = ({ value }) => {
        const { store } = this.props
        const { survey } = store
        survey.metadata.taxonomy.templateLicenceType = value
        surveyApi.updateSettings({
            templateLicenceType: value,
            allowQuotas: survey.metadata.allowQuotas,
        }, store)
    }

    onDateChange = ({ value, name }) => {
        switch (name) {
            case 'eventOpenDate':
                this.eventOpenDate = moment(value)
                this.changeEventOpenDate(value)
                break
            case 'eventCloseDate':
                this.eventCloseDate = moment(value)
                this.changeEventCloseDate(value)
                break
            case 'surveyCloseDate':
                this.changeSurveyCloseDate(value)
                break
            case 'surveyCloseTime':
                this.changeSurveyCloseDateTime(value)
                break
            default:
                break
        }
    }

    checkPrimary = async () => {
        const { store, surveyId } = this.props
        const { survey } = store
        const surveyType = R.pathOr(undefined, ['metadata', 'taxonomy', 'surveyType'], survey)
        if (surveyType !== 'PE') {
            this.isPrimary = false
            return
        }

        let url = '/survey/isPrimary?'
        url += `surveyType=${surveyType}`
        url += `&respondentType=${survey.metadata.taxonomy.respondentType}`
        url += `&year=${survey.metadata.closeDate.year()}`
        url += `&productId=${survey.metadata.productInfo.productId}`

        const primaryCheck = await this.store.http.get(url)
        const primarySurvey = R.pathOr([], ['primarySurvey'], primaryCheck).map((s) => s.surveyId_txt)
        this.isPrimary = primarySurvey.includes(surveyId.toUpperCase())
    }

    setIsPrimary = async () => {
        const { store, surveyId } = this.props
        const { survey, surveyToken } = store
        const { isPrimary } = this
        const { industrySpecificInfo } = survey.metadata.productInfo
        const { productType, endDate } = industrySpecificInfo

        const body = {
            isPrimary,
            productId: survey.metadata.productInfo.productId,
            surveyType: survey.metadata.taxonomy.surveyType,
            respondentType: survey.metadata.taxonomy.respondentType,
            productType,
            year: endDate.year(),
        }

        try {
            store.http.put(`/api/survey/${surveyId}/isprimary`, JSON.stringify(body), surveyToken)
            survey.metadata.isPrimary = isPrimary
            this.isPrimary = isPrimary
            store.addNotification(null, 'Primary setting updated', 'success')
        } catch (e) {
            store.addNotification(null, 'Error - unable to update primary setting', 'error')
        }
    }

    changeIsTest = () => {
        this.isTest = !this.isTest
        this.survey.metadata.isTest = this.isTest
        surveyApi.updateSettings({
            isTest: this.isTest,
            allowQuotas: this.survey.metadata.allowQuotas,
        }, this.store)
    }

    getCities = async (countryCode) => {
        const url = `/cities?country=${countryCode}&addOther=true`
        const cities = await this.store.http.get(url)
        return cities.map(({ city }) => ({
            label: city,
            value: city,
        }))
    }

    getVenues = (city) => new Promise((resolve, reject) => {
        let url = '/venues'
        url += `?city=${city}`
        url += '&active=1'
        url += '&addOther=true'
        url += `&country=${this.store.selectedCountry.value}`
        this.store.http.get(url)
            .then((response) => {
                resolve(response.map(({ name, venueId }) => ({
                    label: name,
                    value: venueId,
                })))
            })
            .catch((e) => {
                this.store.addNotification(null, e.message, 'error')
            })
    })

    getVenue = () => {
        const { survey } = this.store
        return new Promise((resolve, reject) => {
            this.store.http.get(`/venue/${survey.metadata.productInfo.industrySpecificInfo.venueId}`)
                .then((response) => {
                    resolve(response)
                })
                .catch((e) => {
                    this.store.addNotification(null, e.message, 'error')
                })
        })
    }

    getStates = (countryCode) => this.store.http.get(`/states/${countryCode}`)

    getStatus = async () => {
        const { survey } = this.store
        const { metadata } = survey
        const { taxonomy, status } = metadata
        const { surveyType } = taxonomy
        const responses = this.store.noOfResponses
        let statusValue = ''
        let style = ''
        let icon = ''
        this.surveyClosed = survey.closed

        if (surveyType === 'EM') {
            const hasLiveResponse = await this.store.http.get(`/surveys/${this.surveyId}/hasliveresponses`)
            if (status === 'Archived') {
                statusValue = 'status_4'
                style = 'archive'
            } else if (hasLiveResponse.length === 0) {
                statusValue = 'Not Started'
                style = 'error'
                icon = 'fa-regular fa-ban'
            } else {
                statusValue = !hasLiveResponse.includes('dropped') ? 'completed' : 'In progress'
                style = !hasLiveResponse.includes('dropped') ? 'success' : 'warning'
                icon = !hasLiveResponse.includes('dropped') ? 'fa-regular fa-circle-check' : 'fa-regular fa-circle-half-stroke'
            }
        } else {
            switch (status) {
                case 'Created':
                    statusValue = responses < 1 ? 'status_2' : 'status_1'
                    style = `${responses < 1 ? 'warning' : 'success'}`
                    break
                case 'Closed':
                    statusValue = 'status_3'
                    style = 'error'
                    break
                case 'Archived':
                    statusValue = 'status_4'
                    style = 'archive'
                    break
                default:
                    break
            }
        }

        this.surveyStatus = {
            style,
            label: i18n.t(statusValue),
            icon,
        }
    }

    getSurveyEmbedding = async () => {
        const { survey } = this.store

        try {
            const results = await this.store.http.get(`/survey/${survey.id}/embed/`, this.store.surveyToken)
            Object.keys(results.embed).forEach((k) => {
                if (k === 'qr') {
                    this.store.surveyQR = Boolean(results.embed[k])
                } else if (k === 'intercept') {
                    this.store.surveyIntercept = Boolean(results.embed[k])
                } else if (k === 'embed') {
                    this.store.surveyEmbed = Boolean(results.embed[k])
                }
            })
        } catch (e) {
            this.store.addNotification(null, e.message, 'error')
        }
    }

    changeCountry = async (obj, progress = true) => {
        const that = this
        const { store } = this.props
        const { survey } = store
        const { metadata } = survey
        const { industry } = metadata.productInfo.industrySpecificInfo
        this.selectedCountry = obj || {
            value: -1,
            label: i18n.t('form.general.select_an_item'),
        }
        if (obj) {
            let url = `/cities?country=${obj.value}&addOther=1`
            this.store.selectedCountry = obj
            if (this.showCeVenueDetails()) {
                url = `/cities/${obj.value}?addOther=1`
                this.selectedStateCE = {
                    value: -1,
                    label: i18n.t('form.general.select_an_item'),
                }
                this.store.http.get(`/states/${obj.value}`)
                    .then((response) => {
                        this.stateCE = response
                        this.selectedStateCE = store.selectedState ? this.stateCE
                            .find((state) => state.label
                                .toLowerCase() === store.selectedState.toLowerCase()) : ''
                        store.selectedState = this.selectedStateCE
                    })
                    .catch((e) => {
                        this.store.addNotification(null, e.message, 'error')
                    })
            }
            await this.store.http.get(url)
                .then((response) => {
                    if (industry === 'CE') {
                        that.cities = response.map((city) => ({
                            label: city.label,
                            value: city.value === -1 ? 'Other, please specify...' : city.value,
                        }))
                    } else {
                        this.cities = response.map(({ city }) => ({
                            label: city,
                            value: city,
                        }))
                    }
                    if (progress) {
                        this.changeCity({
                            value: -1,
                            label: i18n.t('form.general.select_an_item'),
                        })
                        this.venueOther = ''
                    }
                    that.citiesEditable = true
                })
                .catch((e) => {
                    this.store.addNotification(null, e.message, 'error')
                })
            if (progress) {
                that.citiesEditable = false
                this.changeCity({
                    value: -1,
                    label: '',
                    loader: true,
                })
            }
        }
    }

    changeStateCE = async (state) => {
        this.selectedStateCE = state
        this.changeCity({
            value: -1,
            label: i18n.t('form.general.select_an_item'),
        })
        this.venueOther = ''
        this.store.selectedState = state
        const data = await this.getCities()
        this.cities = data
    }

    changeCity = (city, progress = true) => {
        const that = this
        this.selectedCity = city || {
            value: -1,
            label: i18n.t('form.general.select_an_item'),
        }
        if (city && city.value !== -1) {
            this.store.selectedCity = city
            let url = '/venues'
            url += `?city=${city.label}`
            url += '&active=1'
            url += '&addOther=true'
            url += `&country=${this.selectedCountry.value}`
            this.store.http.get(url)
                .then((response) => {
                    that.venues = response.map(({ name, venueId }) => ({
                        label: name,
                        value: venueId,
                    }))
                    if (progress) {
                        this.changeVenue({
                            value: false,
                            label: i18n.t('form.general.select_an_item'),
                        })
                        this.venueOther = ''
                    }
                    that.venuesEditable = true
                })
                .catch((e) => {
                    this.store.addNotification(null, e.message, 'error')
                })
            if (progress) {
                that.venuesEditable = false
                this.changeVenue({
                    value: false,
                    label: '',
                    loader: true,
                })
                this.venueOther = ''
            }
        } else {
            that.venuesEditable = false
            this.changeVenue({
                value: false,
                label: i18n.t('form.general.select_an_item'),
            }, false)
        }
    }

    changeVenue = (venue, progress = true) => {
        const { store } = this.props
        const { survey } = store
        this.selectedVenue = venue || {}
        if (venue) {
            store.selectedVenue = venue
            survey.metadata.productInfo.industrySpecificInfo.venueId = this.selectedVenue.value
        } else {
            store.selectedVenue = {}
            survey.metadata.productInfo.industrySpecificInfo.venueId = undefined
        }
        if (survey.metadata.productInfo.industrySpecificInfo.industry === 'CE' && progress) {
            survey.metadata.productInfo.industrySpecificInfo.venue = {
                country: this.store.selectedCountry,
                city: this.store.selectedCity,
                state: this.store.selectedState,
                venue: this.store.selectedVenue,
            }
        }
        this.validate()
        if (this.allowUpdate && survey.saveOnChange && !validator.errors.get('venue')) {
            surveyApi.updateSettings({
                productInfo: survey.metadata.productInfo.toJSON(),
                allowQuotas: survey.metadata.allowQuotas,
            }, store)
        }
    }

    validate = () => {
        const { store } = this.props
        const { survey } = store
        if (store.venueOther) {
            validator.errors.set('venue', (!store.venueOther || !survey.metadata.productInfo.industrySpecificInfo.venueId))
        } else {
            validator.errors.set('venue', (!survey.metadata.productInfo.industrySpecificInfo.venueId || survey.metadata.productInfo.industrySpecificInfo.venueId < 1))
        }
    }

    createVenue = () => {
        const that = this
        return new Promise((resolve, reject) => {
            const venueData = {
                venueId: 0,
                name: this.store.venueOther,
                city: this.store.selectedCity.label,
                country: this.store.selectedCountry.value,
                active: 1,
            }
            this.store.http.post('/venue', JSON.stringify(venueData))
                .then((response) => {
                    that.venues.push({
                        value: response.venueId,
                        label: this.store.venueOther,
                    })
                    that.changeVenue({
                        value: response.venueId,
                        label: this.store.venueOther,
                    })
                    resolve()
                })
                .catch((e) => {
                    reject(e)
                })
        })
    }

    validateVenueOther = async () => {
        const { store } = this.props
        if (store.venueOther && this.survey.saveOnChange) {
            await this.createVenue()
        } else {
            validator.errors.set('venue', !store.venueOther)
        }
    }

    setVenueother = (e) => {
        this.venueOther = e.target.value
        this.store.venueOther = e.target.value
    }

    onCityOtherEnter = () => {
        this.selectedCity = {
            label: this.cityother,
            value: this.cityother,
        }
        this.store.selectedCity = this.selectedCity
        this.changeVenue({
            value: -1,
            label: 'Other, please specify...',
        })
        this.allowEditCityotherEV = !this.allowEditCityotherEV
    }

    setCityother = (e) => {
        this.cityother = e.target.value
        this.store.cityother = e.target.value
    }

    changeSelectMergeFields = (mergeFieldId, value) => {
        this.changeMergeFields(mergeFieldId, value)
        this.updateMergeFields()
    }

    changeMergeFields = (mergeFieldId, value) => {
        const { store } = this.props
        const { survey } = store
        const { mergefields } = survey
        const { langcode } = store
        survey.mergefields = { ...mergefields, [mergeFieldId]: { [langcode]: value } }
    }

    updateMergeFields = async () => {
        const { store } = this.props
        const { survey, surveyToken } = store

        const body = { mergefields: survey.mergefields }

        try {
            await store.http.put(`/api/survey/${survey.id}/mergefields`, JSON.stringify(body), surveyToken)
        } catch (e) {
            this.store.addNotification(null, e.message, 'error')
        }
    }

    revertSurveyCloseDate = () => {
        const { store } = this.props
        const { survey } = store

        this.toggleConfirmSurveyCloseModal()
        survey.metadata.closeDate = this.oldSurveyCloseDate
        this.surveycloseDate = moment(this.oldSurveyCloseDate)
        Reflect.deleteProperty(this, 'oldSurveyCloseDate')
    }

    confirmClose = () => {
        const { store } = this.props
        const { survey } = store

        this.toggleConfirmSurveyCloseModal()
        survey.closed = true
        this.surveyClosed = true
        const date = new Date(survey.metadata.closeDate)
        surveyApi.updateSettings({
            closeDate: date.getTime(),
            allowQuotas: survey.metadata.allowQuotas,
        }, store)
        if (survey.metadata.status !== 'Archived') {
            if (survey.closed) {
                survey.metadata.status = 'Closed'
            } else {
                survey.metadata.status = 'Created'
            }
        }
        Reflect.deleteProperty(this, 'oldSurveyCloseDate')
    }

    updateSurveyCloseDate = (obj) => {
        const { store } = this.props
        const { survey } = store
        this.oldSurveyCloseDate = survey.metadata.closeDate
        survey.metadata.closeDate = obj
        if (survey.saveOnChange && survey.metadata.closeDate) {
            const date = new Date(obj)
            const isClosed = (date.getTime() <= new Date().getTime())

            if (isClosed) {
                this.toggleConfirmSurveyCloseModal()
                return
            }

            survey.closed = false
            surveyApi.updateSettings({
                closeDate: date.getTime(),
                allowQuotas: survey.metadata.allowQuotas,
            }, store)
            survey.closed = (obj.isBefore(moment().utc()))
            if (survey.metadata.status !== 'Archived') {
                if (survey.closed) {
                    survey.metadata.status = 'Closed'
                } else {
                    survey.metadata.status = 'Created'
                }
            }
        }
        Reflect.deleteProperty(this, 'oldSurveyCloseDate')
        this.getStatus()
    }

    changeSurveyCloseDateTime = (value) => {
        this.surveycloseDate = value
        this.updateSurveyCloseDate(value.utc())
    }

    changeSurveyCloseDate = (value) => {
        const { store } = this.props
        const { survey } = store
        const currentDateTime = moment(survey.metadata.closeDate).tz(this.store.timeZone)

        const newDateTime = currentDateTime
            .date(value.date())
            .month(value.month())
            .year(value.year())

        this.surveycloseDate = newDateTime
        this.updateSurveyCloseDate(newDateTime.utc())
    }

    setShowLanguageWarning = (locale) => {
        const { store } = this.props
        const { survey } = store
        const surveyLocales = survey.metadata.locales
            .reduce((set, locale) => set.add(locale), new Set())
        const enLocales = ['en_GB', 'en_US']

        this.showLocaleWarning = (
            enLocales.includes(locale)
            && enLocales.every((l) => surveyLocales.has(l))
        )
    }

    changeSelectedLanguages = (obj, languageOption) => {
        const { store } = this.props
        const { survey } = store
        const { value } = languageOption
        if (value === survey.metadata.defaultLocale) {
            return
        }
        if (obj.value) {
            survey.metadata.addLanguage(value)
            this.setShowLanguageWarning(value)
        } else {
            survey.metadata.removeLanguage(value)
        }
        store.surveyLanguages = survey.metadata.locales
            .map((locale) => ({ value: locale, label: store.clientLocales[locale] }))
        this.validateLanguages()
        if (survey.saveOnChange) {
            surveyApi.updateSettings({
                locales: survey.metadata.locales,
                allowQuotas: survey.metadata.allowQuotas,
            }, store)
        }
        this.getPrimaryLanguages()
    }

    validateLanguages = () => {
        const { store } = this.props
        const { survey } = store
        validator.errors.set('locales', (survey.metadata.locales.length === 0))
    }

    closeSurvey = () => {
        const { store } = this.props
        const { survey } = store
        survey.metadata.closeDate = moment()
        const date = new Date(survey.metadata.closeDate)
        date.setSeconds(0)
        this.surveycloseDate = moment(date)
        surveyApi.updateSettings({
            closeDate: date.getTime(),
            allowQuotas: survey.metadata.allowQuotas,
        }, store)
        survey.closed = true
        if (survey.metadata.status !== 'Archived') {
            survey.metadata.status = 'Closed'
        }
        store.surveyCloseConfirm = false
        this.surveyClosed = true
        this.getStatus()
    }

    deleteSurveyModelOpen = () => {
        this.deleteModalOpen = true
    }

    toggleOpenSurveyModal = (val) => {
        if (val) this.isOpenSurveyModalOpen = val
        else this.isOpenSurveyModalOpen = !this.isOpenSurveyModalOpen
    }

    toggleConfirmSurveyCloseModal = () => {
        this.isConfirmSurveyCloseOpen = !this.isConfirmSurveyCloseOpen
    }

    onDeleteSurvey = () => {
        const { store } = this.props
        const { survey } = store
        store.surveyDeleteConfirm = false
        survey.metadata.status = 'Archived'
        this.getStatus()
        surveyApi.updateSettings({
            surveyStatus: 'Archived',
            allowQuotas: survey.metadata.allowQuotas,
        }, store)
        this.deleteModalHide()
    }

    deleteModalHide = () => {
        const { store } = this.props
        store.surveyDeleteConfirm = false
        this.deleteModalOpen = false
    }

    restoreSurvey = () => {
        const { store } = this.props
        const { survey } = store
        survey.metadata.status = 'Created'
        surveyApi.updateSettings({
            surveyStatus: 'Created',
            allowQuotas: survey.metadata.allowQuotas,
        }, store)
        this.getStatus()
    }

    showCeVenueDetails = () => {
        const { store } = this.props
        const { survey } = store
        const { industry, eventType } = survey.metadata.productInfo.industrySpecificInfo
        const { surveyType } = survey.metadata.taxonomy
        return industry === 'CE' && (eventType !== 'V' || surveyType === 'EM')
    }

    handleClosePublishmodal = () => { this.showPublishConfirmationModal = false }

    getTemplateParams = () => {
        const { store } = this.props
        const { survey } = store
        if (!survey) return {}
        const { respondentType, surveyType } = survey.metadata.taxonomy
        const { industry, productType } = survey.metadata.productInfo.industrySpecificInfo
        const { portfolioId, divisionId } = survey
        return {
            respondentType, surveyType, industry, productType, portfolioId, divisionId
        }
    }
}
export default SettingStore
